var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.25l5.5 5.5-5.5 5.5",
    stroke: "#1E2442",
    strokeWidth: 2.42
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDkgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjc1IDEuMjVMNy4yNSA2Ljc1TDEuNzUgMTIuMjUiIHN0cm9rZT0iIzFFMjQ0MiIgc3Ryb2tlLXdpZHRoPSIyLjQyIi8+Cjwvc3ZnPgo=";
export { SvgArrow as ReactComponent };